import { Briefcase, Users } from 'lucide-react'
import { AppPaths } from '@/config/app-paths'
import type { StaffNavContext } from '../staff-nav-context'
import { group, leaf, type StaffNavGroup } from '../nav-node'

export function buildClientGroup(ctx: StaffNavContext): StaffNavGroup | null {
  if (!ctx.showClientApplicants) return null
  return group('client', 'Client', Briefcase, ['client'], [
    leaf('client_applicants', 'My Applicants', AppPaths.clientApplicants, Users, [
      'applicants',
    ]),
  ])
}
